<template>
  <div id="app" class="g-app-wrapper">
    <g-nav @noticeType="noticeType"></g-nav>
    <!-- <g-NewNav @noticeType="noticeType"></g-NewNav> -->
    <div :style="{ marginTop: typeTip ? '102px' : '67px' }" class="g-main" ref="navFlag">
      <keep-alive :include="keepAliveList">
        <router-view v-if="isRouterAlive"></router-view>
      </keep-alive>
    </div>
    <g-footer></g-footer>
    <fixed-btn></fixed-btn>
    <c-progress ref="progress" :percentage="progressPercentage" :text="progressText"></c-progress>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import * as util from 'assets/js/util'
import nav from 'components/common/nav/nav'
// import newNav from 'components/common/nav/newNav'
import footer from 'components/common/footer/footer'
import fixedBtn from 'components/common/fixed/fixedNew'
import progress from 'base/progressGlobal/progressGlobal'

export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload,
      progressClose: this.progressClose,
      progressChange: this.progressChange,
      progressOpen: this.progressOpen
    }
  },
  data() {
    return {
      keepAliveList: /^KA_root/,
      isRouterAlive: true,
      progressText: '',
      progressPercentage: 0,
      typeTip: 'false'
    }
  },
  created() {},
  mounted() {},
  methods: {
    noticeType(type) {
      this.typeTip = type
      // console.log(type, '22222323')
    },
    reload() {
      this.isRouterAlive = !this.isRouterAlive
    },
    progressChange(text, percentage) {
      this.progressText = text
      this.progressPercentage = percentage
    },
    progressOpen() {
      this.$refs.progress.show()
    },
    progressClose() {
      this.$refs.progress.hide()
    },
    ...mapActions(['updateUserInfo', 'removeOrderState'])
  },
  components: {
    'g-nav': nav,
    // 'g-NewNav': newNav,
    'g-footer': footer,
    fixedBtn,
    'c-progress': progress
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import '~assets/scss/compile';
@import 'baseFrame';
</style>



// WEBPACK FOOTER //
// src/components/baseFrame/baseFrame.vue